import Notifier from 'common/helpers/Notifier';
import { useInvalidateQueries, useUpdateRecord } from './APIHooks';

export const useUpdateInteraction = (mutationConfig = {}) => {
  const invalidateQueries = useInvalidateQueries();

  return useUpdateRecord('interaction', {
    mutationConfig: {
      onError: () => {
        Notifier.dispatch('error', 'Failed to update interaction...');
      },
      onSettled: () => {
        invalidateQueries('interaction');
      },
      ...mutationConfig,
    },
  });
};
